import Cookieconsent from '@components/partials/common/cookieConsent';
import Meta from '@components/partials/common/meta';
import PromoVideo from '@components/partials/common/promoVideo';
import Head from 'next/head';
export default function Base({
    children,
    performer,
    currentLang
}: {
    children: React.ReactNode;
    performer: string;
    currentLang: string;
}): JSX.Element {


    return (
        <>
            <Head>
                <Meta />
                <link
                    href="https://fonts.googleapis.com/css2?family=La+Belle+Aurore:wght@400&family=Niramit:wght@400&family=Niramit:wght@700&display=swap"
                    rel="stylesheet"
                />
                <meta name="Rating" content="mature" />
                <meta name="RATING" content="RTA-5042-1996-1400-1577-RTA" />
                <meta name="theme-color" content="#FAFAFA" />
                <link rel="shortcut icon" href="https://assets.camrabbit.sex/favicon-cr.png" />
            </Head>
            {children}
            <PromoVideo />
            <Cookieconsent currentLang={currentLang} />
        </>
    );
}
